module.exports = __webpack_public_path__ + "img/29.7.Chla.720570a0.png";